module.exports = {"svg":{"$":{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"},"title":["UI_Map_16"],"path":[{"$":{"d":"M8,0A4.89,4.89,0,0,0,3,4.78c0,2.54,4.47,7.61,4.66,7.82L8,13l.31-.35C8.53,12.39,13,7.31,13,4.78A4.89,4.89,0,0,0,8,0ZM8,7.29A2.46,2.46,0,0,1,5.54,4.86a2.49,2.49,0,0,1,5,0A2.46,2.46,0,0,1,8,7.29ZM3,11H4.48c.26.36.52.69.77,1H3.57l-1.8,3H14.23l-1.8-3H10.8c.25-.31.51-.64.77-1H13l3,5H0Z","fill":"#464646"}}]}}


//////////////////
// WEBPACK FOOTER
// ./node_modules/xml-loader!./src/svg/UI_Map_16.svg
// module id = UnzS
// module chunks = 1